
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/devops-privileged-access",
      function () {
        return require("private-next-pages/solutions/devops-privileged-access.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/devops-privileged-access"])
      });
    }
  